import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { ExtractionsReviewQueue } from '@/features/extractions'

export const Route = createFileRoute(
  '/_authenticated/_organization/extractions/',
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: ExtractionsReviewQueue,
})
